import { all, call, put, fork, takeEvery } from 'redux-saga/effects';
import { sendStat } from '../../hooks/sendStat';
import { callApi } from '../../utils/callApi';
import { TYPE_EVENT_SEND_MESSAGE } from '../../utils/consts';
import { ApiEvents } from '../../utils/SocketEvents';
import {
  ClosePrivateChat,
  GetPrivateChats,
  OpenPrivateChat,
  SendPrivateMessage,
  TypeClosePrivateChatR,
  TypeGetPrivateChatsR,
  TypeOpenPrivateChatR,
  TypeSendPrivateMessageR,
} from './actions';
import ActionTypes, { TPrivateChat, TPrivateChatState, TPrivateMessage } from './types';

function* getPrivateChats(action: ReturnType<typeof GetPrivateChats.request>): Generator {
  const { data, callBack } = action.payload as TypeGetPrivateChatsR;

  let success = true;
  try {
    const resp = (yield call(callApi, {
      method: 'post',
      data,
      path: ApiEvents.getPChats,
    })) as TPrivateChatState['privateChats'];
    yield put(GetPrivateChats.success(resp));
  } catch (e) {
    success = false;
    yield put(GetPrivateChats.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}

function* sendPrivateMessage(action: ReturnType<typeof SendPrivateMessage.request>): Generator {
  const { data, callBack } = action.payload as TypeSendPrivateMessageR;

  let success = true;
  try {
    const resp = (yield call(callApi, {
      method: 'post',
      data,
      path: ApiEvents.sendPMessage,
    })) as TPrivateMessage;
    sendStat(TYPE_EVENT_SEND_MESSAGE);
    yield put(SendPrivateMessage.success(resp));
  } catch (e) {
    success = false;
    yield put(SendPrivateMessage.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}

function* openPrivateChat(action: ReturnType<typeof OpenPrivateChat.request>): Generator {
  const { data, callBack } = action.payload as TypeOpenPrivateChatR;

  let success = true;
  try {
    const resp = (yield call(callApi, {
      method: 'post',
      data,
      path: ApiEvents.openPChat,
    })) as TPrivateChat;
    yield put(OpenPrivateChat.success(resp));
  } catch (e) {
    success = false;
    yield put(OpenPrivateChat.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}

function* closePrivateChat(action: ReturnType<typeof ClosePrivateChat.request>): Generator {
  const { data, callBack } = action.payload as TypeClosePrivateChatR;

  let success = true;
  try {
    const resp = (yield call(callApi, {
      method: 'post',
      data,
      path: ApiEvents.closePChat,
    })) as TPrivateChat;
    yield put(ClosePrivateChat.success(resp));
  } catch (e) {
    success = false;
    yield put(ClosePrivateChat.error(e as string));
  } finally {
    if (callBack) yield call(callBack, success);
  }
}

function* watchFetchRequest() {
  yield takeEvery(ActionTypes.GET_PRIVATE_CHATS_R, getPrivateChats);
  yield takeEvery(ActionTypes.SEND_PRIVATE_MESSAGE_R, sendPrivateMessage);
  yield takeEvery(ActionTypes.OPEN_PRIVATE_CHAT_R, openPrivateChat);
  yield takeEvery(ActionTypes.CLOSE_PRIVATE_CHAT_R, closePrivateChat);
}

export default function* privateChatSaga() {
  yield all([fork(watchFetchRequest)]);
}
